/** localStorage for Q7.1 — where respondents buy EVO refills (single choice; stored as one-element array). */
export const Q7_1_STORAGE_KEY = 'ploomsurvey:q7_1';

export const Q7_1_OUTLETS = [
  '7 - Eleven',
  'KK Mart',
  'Family Mart',
  'MyNews',
  'Shell',
  'Happy Mart',
  'Bila-Bila Mart',
  '168 Store',
] as const;

export type Q7_1Answers = {
  /** Outlet labels as shown in the UI (subset of `Q7_1_OUTLETS`). */
  selectedOutlets: string[];
};

export function readQ7_1Answers(): Q7_1Answers | null {
  try {
    const raw = localStorage.getItem(Q7_1_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as unknown;
    if (typeof o !== 'object' || o === null) return null;
    const sel = (o as { selectedOutlets?: unknown }).selectedOutlets;
    if (!Array.isArray(sel)) return null;
    const selectedOutlets = sel.filter((x): x is string => typeof x === 'string');
    /** Legacy data may have multiple selections; only the first is kept. */
    return {
      selectedOutlets: selectedOutlets.length > 1 ? [selectedOutlets[0]] : selectedOutlets,
    };
  } catch {
    return null;
  }
}

export function writeQ7_1Answers(data: Q7_1Answers): void {
  try {
    localStorage.setItem(Q7_1_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function clearQ7_1Answers(): void {
  try {
    localStorage.removeItem(Q7_1_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isQ7_1Complete(): boolean {
  const a = readQ7_1Answers();
  return a != null && a.selectedOutlets.length > 0;
}
